import React from "react";
import styled from "styled-components";

import Layout from "@components/Layout";
import PartnerCategoriesAddForm from "./PartnerCategoriesAddForm";

import { Container } from "@styles/grid";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 3rem 5.5rem 5.5rem;
`;

const PartnerCategoriesAdd = () => {
  return (
    <Layout pageTitle="Add Partner Category">
      <Container>
        <Content>
          <PartnerCategoriesAddForm />
        </Content>
      </Container>
    </Layout>
  );
};

export default PartnerCategoriesAdd;
